import { EnumServiceType, OrderRequestEnum } from "../../enumeration";
import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { EmergencyParms, UserSessionService, OutpatientParms } from "../../shared";
import { Subject, Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs/operators";
import { getDateObj } from '../../shared/date.service';
import { ToastService, ModalService } from "../../blocks";

import { CancelServiceComponent } from "../../pricing/cancel-service/cancel-service.component";
import { CallData } from "../call-center-reservation";
import { ModifyAppointmentComponent } from "../../outpatient/out-pat-appointment/out-pat-reservation/modify-appointment/modify-appointment.component";
import { ReservationCallModifyAppointmentComponent } from "./reservation-call-modify-appointment/reservation-call-modify-appointment.component";
import { CallCenterService } from "../call-center-list/call-center-list.service";

@Component({
  selector: 'app-reservation-call',
  templateUrl: './reservation-call.component.html',
  styleUrls: ['./reservation-call.component.css']
})
export class ReservationCallComponent implements OnInit {
  dynamicComponent: any;
  sendMessageFlag: boolean = false;

  orderType = EnumServiceType.Any;
  orderRequest = OrderRequestEnum.orderRequest;
  @Input() callFalg: number;
  @Input() activeTapIndex: Observable<number>;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('popup') content: any;
  private visitedActions: any = {};
  breadCrumbData: any;
  private activeAction: any;
  totalRecords: number = 0;
  checkDocId: number = 0;
  rowSelected: boolean = false;
  showOrdersArea: boolean = false;
  filterArea: boolean = true;
  showlist: boolean = true;
  showEditArea: boolean = false;
  patientInfo: any;
  gridData: any;
  row;
  outPatientObj: OutpatientParms = <OutpatientParms>{};

  mode: number;
  groupingArray: any[];
  filteredPatientList: any[];
  searchObj: EmergencyParms = <EmergencyParms>{};
  showBreadCrumb: boolean;
  @Input() myTapNumber: number;
  selectedService: any;
  constructor(
    private _userSessionService: UserSessionService
    , private _toastService: ToastService,
    private _modalService: ModalService,
    private _callCenterService: CallCenterService,
    public translate: TranslateService) { }

  ngOnInit() {
    this.sendSmsFlag()
    this.getReservationParms$();

  }

  getActiveAction(_row: any, appCodes: any[]) {
    let activeActions = [];
    activeActions = appCodes;
    return activeActions;
  }


  paginate(_parms: any) {
    this.searchObj.offset = _parms.first;
    this.searchObj.pageSize = _parms.rows;
    this.getGridData();
  }

  setBreadCrumb(type: string, code, nameAr?, nameEn?, areaName?) {
    this.breadCrumbData = Object.assign({},
      { type: type, code: code, nameAr: nameAr, nameEn: nameEn, areaName: areaName });
  }


  getReservationParms$() {
    this._userSessionService.subscribeToKey$('_callReservation').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        if (keys.name == '_callReservation' && keys.value) {
          this.getReservationVisits();
        }
      })
  }
  obj: any
 onLazyLoad(_parms: Event, _filter: boolean) {
    if (_filter) {
      this.searchObj.fastSearchData = _parms.currentTarget['value'];
      this.getGridData();
    }
  }
  mangeDataArray(filteredPatientList: any[]) {
    this.obj = <any>{};

    let x = filteredPatientList;

    if (filteredPatientList.length > 0) {
      this.obj.totalReservationNum = filteredPatientList.length
      this.obj.totalNotReservationNum = filteredPatientList.filter(el => el.arrivalResult == null).length
      this.obj.totalCancelReservationNum = filteredPatientList.filter(el => el.arrivalResult == -1).length


    }


  }
  getReservationVisits() {
    this.outPatientObj = <OutpatientParms>this._userSessionService.getSessionKey('_callReservation')
    if (this.outPatientObj) {
      this.outPatientObj.offset = 0;
      this.outPatientObj.pageSize = 10;
      this.searchObj.phoneNumber = null
      this.getGridData();
    }
  }
  getGridData() {
    this.filteredPatientList = [];
    this.searchObj.DocCode = this.outPatientObj.DocCode
    this.searchObj.callReason = 3
    this.searchObj.SpecialityId = this.outPatientObj.SpecialityId
    this.searchObj.ReservationDate = getDateObj(this.outPatientObj.ReservationDate)
    this._callCenterService.getCallsData(this.searchObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.filteredPatientList = res.data;
            this.mangeDataArray(this.filteredPatientList)
          }
        },
        error => console.log(error),
        () => {
          //  this.updatePaginator();
        });
  }
  reservationPatient(ev: any, row: any) {
    if (ev && ev.code && !ev.AutoEmitted) {
      row.docId = row.docId ? row.docId : ev.code;
      this._userSessionService.eventEmit('CallConfirmationAndReservation', row);
 
    }
  }
  onIconActionClick(action: any, rowData: any) {
    let actionCode = action.serial;
    action['code'] = action.serial;
    if (actionCode == 300) {
      if (rowData.docId) {
        this._userSessionService.setSessionKey('CallConfirmationAndReservation', rowData);
      } else {
        rowData['checkNoDoctor'] = !rowData['checkNoDoctor'];
        this._toastService.activateMsg('UI287');
      }
      debugger
    }
    if (actionCode == 6776) {
      rowData['type'] = 10
      this.cancelClicked(rowData);
    }
    if (actionCode == 305) {
      this._modalService.activeMes(' هل تريد الغاء حضور ' + rowData.fullnameAr, 'Do You Want To Cancel Attend ' + rowData.fullnameEn).then(responseOK => {
        if (responseOK) {

          let patient: CallData = <CallData>{}
          patient = rowData
          patient.arrivalResult = 3
          this._callCenterService.changeCallerStatus(patient)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              res => {
                if (res && res.data && res.data.length > 0) {
                }
              },
              error => console.log(error),
              () => {
              });
        }
      });
    }
    if (actionCode == 6958) {
      this.selectedService= rowData;
      this.EditClicked();
    }
    if (actionCode == 6960) {
      this.confirmationCallDataReservation(rowData);
    }
  }
  confirmationCallDataReservation(rowData) {
    this._modalService.activeMes(' هل تريد تاكيد الحجز   ' + rowData.fullnameAr, 'Do You Want To ComfirAm Attend ' + rowData.fullnameEn).then(responseOK => {
      if (responseOK) {

        let patient: CallData = <CallData>{}
        patient = rowData
        this._callCenterService.confarmationReservationCall(patient)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            res => {
              if (res && res.data && res.data.length > 0) {
              }
            },
            error => console.log(error),
            () => {
            });
      }
    });
  }



  EditClicked() {
    this.dynamicComponent = ReservationCallModifyAppointmentComponent;
    this.content.openModal("ReservationCallModifyAppointmentComponent", "Reservations", this.selectedService);

  }
  cancelClicked(data: any) {
    if (this.sendMessageFlag) {
      data.sendMessageFlag = true
    data.smsTrigger = 5
      data.fieldName = 'deletePatientSMS'
    }//الالغاء حجززات مركز الاتصالت
    this.dynamicComponent = CancelServiceComponent;
    this.content.openModal("CancelServiceComponent", "Reservations", data);
  }
  onpopupClose(parms: any) {

    if (parms && parms.output == 'Cross click') {
      if (parms.name == "CancelServiceComponent") {
        this.getGridData();
      }
      this._userSessionService.closeModalKey('ModifyAppointmentComponent', parms.output);
    }
    else if (parms && parms.output) {
      this.getReservationVisits();
    }

  }
  sendSmsFlag() {
    this._callCenterService.getStockModuleSettings({ moduleId: 10123 })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.sendMessageFlag = +c.data[0]['sendMsgFlag'] == 1 ? true : false;
        }
      });
  }


  showFilterInputs : boolean;
  onFilterClick(){ 

this.showFilterInputs =  !this.showFilterInputs
  }

  onSearchClick(){ 
  this.getGridData();
  }
}
